import React from 'react';
import { TECHNOLOGY_TABS, TECHNOLOGY_NAV_TABS } from '../utils/technologyTabs';
import StartLockedDepartmentPage from '../components/start/StartLockedDepartmentPage';

/**
 * Locked preview of the portal Technology hub (/portal/technology).
 *
 * The Estimating Template grant unlocks the standalone /start page that still
 * backs it — in the portal it now lives under the JobTread Imports tab.
 */
const TECHNOLOGY_UNLOCKS = {
  'tech-stack': { freePage: 'technology/crmtechstack', to: '/start/technology/crmtechstack' },
  'jobtread-imports': {
    freePage: 'technology/estimating-template',
    to: '/start/technology/estimating-template',
  },
};

const StartTechnology = () => (
  <StartLockedDepartmentPage
    title="Technology"
    tabs={TECHNOLOGY_NAV_TABS}
    allTabs={TECHNOLOGY_TABS}
    unlockMap={TECHNOLOGY_UNLOCKS}
  />
);

export default StartTechnology;
